import React from 'react'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { measurements } from '@mobi/component-library/Foundations'
import {
  KAMBI_BETSLIP_DIV_CLASS,
  KAMBI_BETSLIP_WRAPPER_DIV_ID,
} from '@core/Areas/KambiClient/constants'
import { shouldApplySafeAreaBottomPadding } from '@core/Settings/cssConditions'
import { selectIsBetslipVisible } from '../../Store/selectors'

/** Renders Kambi bet slip - NOT within react-router routes */
export const KambiBetSlip: React.FC = React.memo(() => {
  const isKambiBetslipVisible = useSelector(selectIsBetslipVisible)

  return (
    <WrapperStyled style={isKambiBetslipVisible ? undefined : { display: 'none' }}>
      <div
        id={KAMBI_BETSLIP_WRAPPER_DIV_ID}
        className={`${KAMBI_BETSLIP_DIV_CLASS} mobi__unset-globals`}
      />
    </WrapperStyled>
  )
})

KambiBetSlip.displayName = 'KambiBetSlip'

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  '.mod-KambiBC-betslip': {
    maxHeight: `calc(100dvh - (${measurements.mobi.headerHeight} + ${measurements.mobi.bottomTabsHeight} + var(--safe-area-inset-bottom, 0px))) !important`,
  },

  ...(shouldApplySafeAreaBottomPadding
    ? {
        '.mod-KambiBC-betslip, .mod-KambiBC-betslip__outer-wrapper-mask': {
          transform: `translateY(calc(calc(${measurements.mobi.bottomTabsHeight} + var(--safe-area-inset-bottom, 0px)) * -1))`,
        },

        '.mod-KambiBC-betslip-container--pinned .mod-KambiBC-betslip, .mod-KambiBC-betslip-container--pinned .mod-KambiBC-betslip__outer-wrapper-mask':
          {
            transform: 'unset',
          },
      }
    : {}),
})
